module.exports = __webpack_public_path__ + "media/images/front/icons/login-467a93d6d18637316f9d62dd39b994d6.png";